import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import About from './views/About'
import Home from './views/Home.vue'
import Login from './components/Login'
import LoginBox from './components/LoginBox'
import RegisterBox from './components/RegisterBox'
import LoginCheck from './components/LoginCheck'
import UserLayout from './views/UserLayout'
import UserDashboard from './components/UserDashboard'
import UserDashboard2 from './components/UserDashboard2'
import UserProfile from './components/UserProfile'
import BasicAgenda from './components/BasicAgenda'
import MainReport from './components/MainReport'
import SsrReport from './components/SsrReport'
import ServerReport from './components/ServerReport'
import RegTest from './components/RegTest'
import AdminRegTest from './components/AdminRegTest'
import RegReport from './components/RegReport'
import AdminTestList from './components/AdminTestList'
import AdminReportList from './components/AdminReportList'
import AdminGerminalList from './components/AdminGerminalList'
import ComboReport from './components/ComboReport'
import Help from './components/Help'
import TestFileDownload from './components/TestFileDownload'
import AdminRetailRegList from './components/AdminRetailRegList'

import store from "./store";

Vue.use(VueRouter)
Vue.use(Vuex)

export default new VueRouter({
    mode: 'history',
    base: __dirname,
    beforeEach: ((to, from, next) => {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!store.state.isAuthenticated) {
                next({path: '/user/login', query: {redirect: to.fullPath}})
            } else {
                next()
            }
        } else {
            next()
            /* всегда так или иначе нужно вызвать next()! */
        }
    }),
    routes: [
        {
            path: '/ssr-report/:reportId/:lang',
            props: true,
            name: 'ssr_report',
            component: SsrReport,
            meta: {requiresAuth: false},
        },
        {
            path: '/home',
            name: 'home',
            redirect: "/home/dashboard",
            component: UserLayout,
            meta: {requiresAuth: true},
            children: [
                {
                    path: 'dashboard',
                    name: 'user_home',
                    meta: {requiresAuth: true},
                    component: UserDashboard
                },
                {
                    path: 'profile',
                    name: 'user_profile',
                    component: UserProfile
                },
                {
                    path: 'agenda',
                    name: 'user_basic_agenda',
                    component: BasicAgenda
                },
                {
                    path: 'help',
                    name: 'help',
                    component: Help
                },
                {
                    path: 'serverReport/:lang',
                    props: true,
                    name: 'server_report',
                    component: ServerReport
                },
                {
                    path: 'report/get/:reportId/:lang',
                    props: true,
                    name: 'get_report',
                    component: MainReport
                },
                {
                    path: 'serverReport',
                    redirect: 'serverReport/ru'
                },
                {
                    path: 'tests',
                    name: 'tests',
                    component: ServerReport, // TODO !!!!!!!!!!!!!!!!!!
                },
                {
                    path: 'tests/reg',
                    name: 'test_reg',
                    component: RegTest,
                },
                {
                    path: 'tests/download/:testId',
                    props: true,
                    name: 'test_download',
                    component: TestFileDownload,
                }
            ]
        },
        {
            path: '/admin',
            name: 'admin',
            redirect: '/admin/reports/list',
            component: Home,
            meta: {requiresAuth: true, level: 3, roles: ['admin']},
            children: [
                {
                    path: 'retail-reg-data/list',
                    name: 'retail_reg_data_list',
                    component: AdminRetailRegList
                },
                {
                    path: 'reports',

                    redirect: '/admin/reports/list',
                },
                {
                    path: 'reports/list',
                    name: 'list_report',
                    component: AdminReportList
                },
                {
                    path: 'reports/germinal-list',
                    name: 'germinal_list_report',
                    component: AdminGerminalList
                },
                {
                    path: 'reports/reg',
                    name: 'reg_report',
                    component: RegReport
                },
                {
                    path: 'report/get/:reportId/:lang',
                    props: true,
                    name: 'admin_get_report',
                    component: MainReport
                },
                {
                    path: 'report/combo/:testId/:lang/:all',
                    props: true,
                    name: 'admin_get_combo_report',
                    component: ComboReport
                },
                {
                    path: 'tests',
                    redirect: '/admin/tests/list',
                    children: [
                        {
                            path: 'reg',
                            component: AdminRegTest
                        }
                    ]
                },
                {
                    path: 'tests/list',
                    component: AdminTestList
                },

                {
                    path: 'help',
                    name: 'admin_help',
                    component: Help
                },

            ]
        },
        {
            path: '/user/login',
            component: LoginBox
        },
        {
            path: '/user/register',
            component: RegisterBox
        },
        {
            path: '/checkLogin',
            props: true,
            component: LoginCheck
        },
        {
            path: '/auth/callback',
            component: {
                template: '<div class="auth-component"></div>'
            }
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/',
            name: 'main',
            redirect: "/home/dashboard",
            //component: About,
            //meta: {requiresAuth: false}
        }
    ]
})

